<template>
  <div>
    <b-tabs
      content-class="mt-4"
      class="tabs-clear my-3"
      nav-class="flex-row w-100"
      :justified="['xs','sm','md'].includes($store.state.breakpoint)"
      lazy
    >
      <!-- TEAM -->
      <b-tab :title="$t('dashboard.team_leaderboard')" active>
        <b-row no-gutters v-if="orgLeaderBoardExist">
          <b-col cols="12" class="d-flex justify-content-end pr-3">
            <span class="text-terciary mr-3 font-weight-semibold">
              {{ $t("dashboard.teams_only_my_organization") }}
            </span>
            <b-form-checkbox v-model="TeamChecked" name="team-only-org" switch class="checkbox-input"/>
          </b-col>
        </b-row>

        <b-row no-gutters class="mt-5">
          <b-col cols="12">
            <MeRankCard :meRankCard="TeamChecked ? TeamLBRankMyOrg : TeamLBRankALLTeam"/>
          </b-col>
        </b-row>

        <b-row no-gutters class="mt-5">
          <b-col cols="12">
            <b-overlay :show="loading">
              <div v-if="TeamChecked">
                <AllRankCard v-for="team in TeamLBMyOrg" :key="'org-'+team.rank" :team="team" class="mb-3"/>
                <div v-if="TeamLBMyOrg.length" v-observe-visibility="TeamLBScrolledToBottom"></div>
              </div>
              <div v-else>
                <AllRankCard v-for="team in TeamLBALLTeam" :key="'all-'+team.rank" :team="team" class="mb-3"/>
                <div v-if="TeamLBALLTeam.length" v-observe-visibility="TeamLBALLTeamScrolledToBottom"></div>
              </div>
            </b-overlay>
          </b-col>
        </b-row>
      </b-tab>

      <!-- INDIVIDUAL -->
      <b-tab :title="$t('dashboard.individual_leaderboard')">
        <b-row no-gutters v-if="orgLeaderBoardExist" class="mb-2">
          <b-col cols="12" class="d-flex justify-content-end">
            <span class="text-terciary mr-3 font-weight-semibold">
              {{ $t("dashboard.individuals_only_my_organization") }}
            </span>
            <b-form-checkbox v-model="IndividualChecked" name="ind-only-org" switch class="checkbox-input"/>
          </b-col>
        </b-row>

        <b-row no-gutters class="mt-5">
          <b-col cols="12">
            <MeRankCard :meRankCard="IndividualChecked ? MyLBRankOrg : MyLBRank"/>
          </b-col>
        </b-row>

        <b-row no-gutters class="mt-5">
          <b-col cols="12">
            <b-overlay :show="loading">
              <div v-if="IndividualChecked">
                <AllRankCard v-for="row in MyLeaderBoard" :key="'myorg-'+row.rank" :team="row" class="mb-3"/>
                <div v-if="MyLeaderBoard.length" v-observe-visibility="ScrolledToBottom"></div>
              </div>
              <div v-else>
                <AllRankCard v-for="row in AllLeaderBoard" :key="'allind-'+row.rank" :team="row" class="mb-3"/>
                <div v-if="AllLeaderBoard.length" v-observe-visibility="AllLeaderBoardScrolledToBottom"></div>
              </div>
            </b-overlay>
          </b-col>
        </b-row>
      </b-tab>

      <!-- ORGANIZATION -->
      <b-tab :title="$t('dashboard.organization_leaderboard')" v-if="OrgLeaderBoard.length">
        <b-row class="mt-4">
          <b-col cols="12">
            <b-overlay :show="loading">
              <div>
                <div v-for="org in OrgLeaderBoard" :key="org.rank" class="mb-4">
                  <b-card :class="org.my_org == '1' && 'my-org-bg'">
                    <div class="d-flex align-items-center pl-1">
                      <span class="h5 text-terciary font-weight-bold mr-3">{{ org.rank }}.</span>
                      <div class="d-flex ml-4 pr-3 text-terciary flex-grow-1 justify-content-between">
                        <span class="font-weight-normal">{{ org.name }}</span>
                        <span>{{ org.points }} {{ $t('points') }}</span>
                      </div>
                    </div>
                  </b-card>
                </div>
                <div v-if="OrgLeaderBoard.length" v-observe-visibility="OrgLeaderBoardScrolledToBottom"></div>
              </div>
            </b-overlay>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import axios from "axios"
import MeRankCard from "@/components/Dashboard/MeRankCard.vue"
import AllRankCard from "@/components/Dashboard/AllRankCard.vue"

export default {
  name: "DashboardLeaderboards",
  components: { MeRankCard, AllRankCard },

  data() {
    const team_checked_storage = localStorage.getItem("team_checked")
    const individual_checked_storage = localStorage.getItem("individual_checked")
    return {
      loading: false,
      orgLeaderBoardExist: null,

      // toggles (preserve keys to keep user prefs)
      TeamChecked: team_checked_storage ? team_checked_storage === "true" : true,
      IndividualChecked: individual_checked_storage ? individual_checked_storage === "true" : true,

      // TEAM state
      TeamLBRankMyOrg: null,
      TeamLBRankALLTeam: null,
      TeamLBMyOrg: [],
      TeamLBMyOrgLink: null,
      TeamLBALLTeam: [],
      TeamLBALLTeamLink: null,

      // INDIVIDUAL state
      MyLBRankOrg: null,
      MyLBRank: null,
      MyLeaderBoard: [],
      MyLeaderBoardLink: null,
      AllLeaderBoard: [],
      AllLeaderBoardLink: null,

      // ORG state
      OrgLeaderBoard: [],
      OrgLeaderBoardLink: null,
    }
  },

  watch: {
    TeamChecked(val) { localStorage.setItem("team_checked", val) },
    IndividualChecked(val) { localStorage.setItem("individual_checked", val) },
  },

  created() {
    // mirrors your existing created() calls
    this.checkOrgLeaderboardExist()
    this.getTeamLeaderboardRankMyOrg()
    this.getTeamLeaderboardAllTeam()
    this.getTeamLeaderboardRankAllTeam()
    this.getTeamLeaderboardMyOrg()
    this.getMyLeaderboardRank()
    this.getMyLeaderboardRankMyOrg()
    this.getMyLeaderboard()
    this.getAllLeaderboard()
    this.getOrgLeaderboard()
  },

  methods: {
    // --- EXISTENCE
    async checkOrgLeaderboardExist() {
      try {
        const res = await axios.get(`/leaderboard/exist`)
        if (res.status === 200) this.orgLeaderBoardExist = res.data?.data ?? null
      } catch ({ response }) {
        this.toastErr(response)
      }
    },

    // --- TEAM
    async getTeamLeaderboardRankMyOrg() {
      try {
        const res = await axios.get(`/leaderboard/my/team/rank/organization`)
        if (res.status === 200) this.TeamLBRankMyOrg = res.data?.data[0] ?? null
      } catch ({ response }) { this.toastErr(response) }
    },
    async getTeamLeaderboardRankAllTeam() {
      try {
        const res = await axios.get(`/leaderboard/my/team/rank`)
        if (res.status === 200) this.TeamLBRankALLTeam = res.data?.data[0] ?? null
      } catch ({ response }) { this.toastErr(response) }
    },
    async getTeamLeaderboardMyOrg(pageURL) {
      await this._pagedFetch({
        pageURL,
        def: `/leaderboard/my/team`,
        sinkItems: (items)=> (this.TeamLBMyOrg = [...this.TeamLBMyOrg, ...items]),
        sinkLinks: (links)=> (this.TeamLBMyOrgLink = links)
      })
    },
    async getTeamLeaderboardAllTeam(pageURL) {
      await this._pagedFetch({
        pageURL,
        def: `/leaderboard/team/all`,
        sinkItems: (items)=> (this.TeamLBALLTeam = [...this.TeamLBALLTeam, ...items]),
        sinkLinks: (links)=> (this.TeamLBALLTeamLink = links)
      })
    },

    // --- INDIVIDUAL
    async getMyLeaderboardRankMyOrg() {
      try {
        const res = await axios.get(`/leaderboard/my/rank/organization`)
        if (res.status === 200) this.MyLBRankOrg = res.data?.data[0] ?? null
      } catch ({ response }) { this.toastErr(response) }
    },
    async getMyLeaderboardRank() {
      try {
        const res = await axios.get(`/leaderboard/my/rank`)
        if (res.status === 200) this.MyLBRank = res.data?.data[0] ?? null
      } catch ({ response }) { this.toastErr(response) }
    },
    async getMyLeaderboard(pageURL) {
      await this._pagedFetch({
        pageURL,
        def: `/leaderboard/my`,
        sinkItems: (items)=> (this.MyLeaderBoard = [...this.MyLeaderBoard, ...items]),
        sinkLinks: (links)=> (this.MyLeaderBoardLink = links)
      })
    },
    async getAllLeaderboard(pageURL) {
      await this._pagedFetch({
        pageURL,
        def: `/leaderboard/all`,
        normalizeUrl: true,
        sinkItems: (items)=> (this.AllLeaderBoard = [...this.AllLeaderBoard, ...items]),
        sinkLinks: (links)=> (this.AllLeaderBoardLink = links)
      })
    },

    // --- ORG
    async getOrgLeaderboard(pageURL) {
      await this._pagedFetch({
        pageURL,
        def: `/leaderboard/organizations`,
        normalizeUrl: true,
        sinkItems: (items)=> (this.OrgLeaderBoard = [...this.OrgLeaderBoard, ...items]),
        sinkLinks: (links)=> (this.OrgLeaderBoardLink = links)
      })
    },

    // --- PAGINATION (DRY helper)
    async _pagedFetch({ pageURL, def, sinkItems, sinkLinks, normalizeUrl }) {
      this.loading = true
      let url = def
      if (pageURL) {
        url = pageURL
        if (normalizeUrl) {
          url = new URL(url)
          url = url.toString().substring(url.origin.length)
          url = url.replace(/^(\/[\w-]+)*\/api\//, "/")
        }
      }
      try {
        const res = await axios.get(url)
        if (res.status === 200) {
          sinkItems(res.data?.data ?? [])
          sinkLinks(res.data?.links ?? null)
        }
      } catch ({ response }) { this.toastErr(response) }
      finally { this.loading = false }
    },

    // --- INFINITE SCROLL handlers
    ScrolledToBottom(isVisible) {
      if (!isVisible || !this.MyLeaderBoardLink?.more_pages) return
      this.getMyLeaderboard(this.MyLeaderBoardLink.next_page_url)
    },
    TeamLBScrolledToBottom(isVisible) {
      if (!isVisible || !this.TeamLBMyOrgLink?.more_pages) return
      this.getTeamLeaderboardMyOrg(this.TeamLBMyOrgLink.next_page_url)
    },
    TeamLBALLTeamScrolledToBottom(isVisible) {
      if (!isVisible || !this.TeamLBALLTeamLink?.more_pages) return
      this.getTeamLeaderboardAllTeam(this.TeamLBALLTeamLink.next_page_url)
    },
    AllLeaderBoardScrolledToBottom(isVisible) {
      if (!isVisible || !this.AllLeaderBoardLink?.more_pages) return
      this.getAllLeaderboard(this.AllLeaderBoardLink.next_page_url)
    },
    OrgLeaderBoardScrolledToBottom(isVisible) {
      if (!isVisible || !this.OrgLeaderBoardLink?.more_pages) return
      this.getOrgLeaderboard(this.OrgLeaderBoardLink.next_page_url)
    },

    // --- shared toast
    toastErr(response) {
      this.$store.dispatch("addToastMessage", {
        type: "danger",
        text: response?.data?.error_message || this.$t("something_went_wrong"),
      })
    },
  },
}
</script>

<style scoped>
.my-org-bg { background: #F0E07D; } /* brand accent */
</style>
